import { MipsQuestionnaire } from "@models/mips-stepper.model";
import { createFeature, createReducer, on } from "@ngrx/store";
import { MipsQuestionnaireActions } from "@store/actions/mips-questionnaire/mips-questionnaire.actions";
export const mipsQuestionnaireFeatureKey = "mipsQuestionnaire";

export interface State {
  mipsQuestionnaire: MipsQuestionnaire;
  isLoaded: boolean;
  isValid: boolean;
  isLoading: boolean;
  isSubmitting: boolean;
  error: string | null;
  submitSuccess: boolean;
  isExporting: boolean;
  exportError: string | null;
}

export const initialState: State = {
  isLoaded: false,
  mipsQuestionnaire: {
    requiredToReport: "",
    reportingType: "",
    reportingLevelIndividual: "no",
    reportingLevelGroup: "no",
    reportingLevelSubgroup: "no",
    specialStatus: "",
    specialStatusSmall: null,
    specialStatusHpsa: null,
    specialStatusRural: null,
    specialStatusNonPatientFacing: null,
    appliedHardship: "",
    hardshipQuality: "no",
    hardshipPromotingInteroperability: "no",
    hardShipImprovementActivities: "no",
    hardshipCost: "no",
    thirdPartyData: "",
  },
  isValid: false,
  isLoading: false,
  isSubmitting: false,
  error: null,
  submitSuccess: false,
  isExporting: false,
  exportError: null,
};

export const reducer = createReducer(
  initialState,
  on(MipsQuestionnaireActions.pageLoaded, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(MipsQuestionnaireActions.validityChanged, (state, { validity }) => ({
    ...state,
    isValid: validity,
  })),
  on(
    MipsQuestionnaireActions.submitMIPSQuestionnaire,
    (state, { mipsQuestionnaire }) => ({
      ...state,
      mipsQuestionnaire,
      isSubmitting: true,
      error: null,
      submitSuccess: false,
    })
  ),
  on(MipsQuestionnaireActions.submitMIPSQuestionnaireSuccess, (state) => ({
    ...state,
    isSubmitting: false,
    submitSuccess: true,
    error: null,
  })),
  on(
    MipsQuestionnaireActions.submitMIPSQuestionnaireFailure,
    (state, { error }) => ({
      ...state,
      isSubmitting: false,
      submitSuccess: false,
      error,
    })
  ),
  on(MipsQuestionnaireActions.loadMIPSQuestionnaire, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),
  on(
    MipsQuestionnaireActions.loadMIPSQuestionnaireSuccess,
    (state, { data }) => ({
      ...state,
      mipsQuestionnaire: data,
      isLoaded: true,
      isLoading: false,
      error: null,
    })
  ),
  on(
    MipsQuestionnaireActions.loadMIPSQuestionnaireFailure,
    (state, { error }) => ({
      ...state,
      isLoading: false,
      error,
    })
  ),
  on(
    MipsQuestionnaireActions.updateMIPSQuestionnaire,
    (state, { mipsQuestionnaire }) => ({
      ...state,
      mipsQuestionnaire,
      isSubmitting: true,
      error: null,
      submitSuccess: false,
    })
  ),
  on(MipsQuestionnaireActions.updateMIPSQuestionnaireSuccess, (state) => ({
    ...state,
    isSubmitting: false,
    submitSuccess: true,
    error: null,
  })),
  on(
    MipsQuestionnaireActions.updateMIPSQuestionnaireFailure,
    (state, { error }) => ({
      ...state,
      isSubmitting: false,
      submitSuccess: false,
      error,
    })
  ),
  on(MipsQuestionnaireActions.exportAllQuestionnaires, (state) => ({
    ...state,
    isExporting: true,
    exportError: null,
  })),
  on(MipsQuestionnaireActions.exportAllQuestionnairesSuccess, (state) => ({
    ...state,
    isExporting: false,
    exportError: null,
  })),
  on(MipsQuestionnaireActions.exportAllQuestionnairesFailure, (state, { error }) => ({
    ...state,
    isExporting: false,
    exportError: error,
  })),
  on(MipsQuestionnaireActions.resetForm, () => initialState)
);

export const mipsQuestionnaireFeature = createFeature({
  name: mipsQuestionnaireFeatureKey,
  reducer,
});